import {Edge, Node, NodeProps as ReactFlowNodeProps} from "@xyflow/react";
import {CustomAction} from "@/api/services/customAction";

export interface NodeProps extends ReactFlowNodeProps {
  data: WorkflowNodeData;
}

export enum SettingParamTypes {
  SELECT = "select",
  NODE_SELECT = "node_select",
  INPUT = "input",
  TEXTAREA = "textarea",
  PROMPT = "prompt",
  ACTIONS = "actions",
  MODAL = "modal",
  OBJECTION = "objection",
  FAQ = "faq",
  CAPTURE = "capture",
}

export enum WorkflowNodeTypes {
  PLACEHOLDER = "placeholder",
  ROOT = "root",
  START = "start",
  TALK = "talk",
  END = "end",
  OBJECTION = "objection",
  ACTION = "action",
  FORM = "form",
  JUMP = "jump",
  STEP = "step",
  BRANCH = "branch",
  GLOBAL = "global",
  INSTRUCTION = "instruction",
}

export enum ActionTypes {
  CUSTOM_ACTION = "custom",
  LIVE_TRANSFER = "transfer",
  REAL_TIME_BOOKING = "booking",
}

export enum SavingState {
  SAVING = "SAVING",
  SAVED = "SAVED",
  ERROR = "ERROR",
  LOADING = "LOADING",
}

export enum VariableTypes {
  VARIABLES = "variables",
  RESULTS = "results",
  CUSTOM_ACTIONS = "custom_actions",
}

export enum FlowMode {
  LIVE = "live",
  TEST = "test",
}

export interface FlowData {
  live: {
    version: number;
    nodes: Node[];
    edges: Edge[];
  };
  test: {
    version: number;
    nodes: Node[];
    edges: Edge[];
  };
}
export enum AssistantType {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

type BookingType = "calcom" | "ghl";
export interface TransferCallAction {
  name?: string;
  trigger?: string;
  phone_number?: string;
  action_id?: string;
  type: ActionTypes.LIVE_TRANSFER;
  missing?: boolean;
}

export interface BookingAction {
  name?: string;
  start_message?: string;
  action_id?: string;
  config?: {
    first_appt_date?: string;
    type?: BookingType;
    prompt?: string;
    title?: string;
  };
  type: ActionTypes.REAL_TIME_BOOKING;
  missing?: boolean;
}

export type Action = CustomAction | TransferCallAction | BookingAction;
export interface ActionLegacy {
  action_id: string;
  name: string;
  description: string;
  action_type: ActionTypes;
  icon: string;
  formatted_name: string;
  http_mode: string;
  action_results: string[];
  parameters_hard_coded: {
    prompt: string;
    description: string;
    first_appt_date: string;
    to_phone_number: string;
    url: string;
    http_mode: string;
    title: string;
    event_type_id: string;
    action_results: string[];
  };
  missing?: boolean;
}

export type PromptVariableAction = {
  formatted_name: string;
  http_method: string;
  variables: string[];
};

export type PromptVariable = Action | string | PromptVariableAction;

export interface WorkflowNodeStyles {
  name: string;
  icon: React.ElementType;
  blueprint: any;
  styles: {
    iconColor?: string;
    iconBackgroundColor?: string;
    iconBorderColor?: string;
    minimapNodeColor?: string;
    miniMapNodeSelectedColor?: string;
    contextColor?: string;
  };
}

export interface SettingsProps {
  selectedNode: Node<WorkflowNodeData>;
  nodes: Node[];
  takeSnapshot: () => void;
  assistantType: AssistantType;
  promptVariables?: any;
}

export type SettingParam = {
  label?: string;
  key: string;
  value:
    | string
    | number
    | boolean
    | undefined
    | null
    | Record<any, string | number | boolean | undefined>[]
    | Action[];
  type: SettingParamTypes;
  placeholder?: string;
  modalSettings?: SettingParam[];
  settingName?: string;
  modalDescription?: string;
  unitName?: string;
  required?: boolean;
  requiredLabel?: string;
  selectOptions?: {name: string; value: string}[];
};

export type WorkflowNodeSetting = {
  title: string;
  description?: string;
  icon?: any;
  params: SettingParam[];
  key?: string;
  scripted_greeting?: string;
  expandedSetting?: boolean;
  action?: Action;
  actions?: Action[];
  global_actions?: Action[];
};

export type WorkflowNodeData = {
  type: WorkflowNodeTypes;
  description?: string;
  instructions?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  settingsTitle?: string;
  nodeTitle?: string;
  settings?: WorkflowNodeSetting[];
  children?: string[];
  parentId?: string;
  label?: string;
  isEmpty?: boolean;
};

export interface FlowIssue {
  type: "error" | "warning";
  message: string;
  nodeId: string;
  nodeType: WorkflowNodeTypes;
  key: string;
  nodeTitle: string;
}

export interface ProcessedNode {
  id: string;
  type: WorkflowNodeTypes;
  data: {
    settings: WorkflowNodeSetting;
    type: WorkflowNodeTypes;
  };
}
